import SubscriptionList from './ListSubscriptions';

export default {
  list: SubscriptionList,
};
